import { Link, useParams } from "react-router-dom";
import { GrooveSnapshotPlayer } from "../GrooveSnapshotPlayer.js";
import { getFamilyRepertoireHubMaterial } from "../repertoire.js";
import { useAsync } from "../useAsync.js";

export function FamilyRepertoireMaterial({ studentId }: { studentId: string }) {
  const { repertoireId = "", resourceId = "" } = useParams<{
    repertoireId: string;
    resourceId: string;
  }>();
  const material = useAsync(
    () => getFamilyRepertoireHubMaterial(studentId, repertoireId, resourceId),
    [studentId, repertoireId, resourceId],
  );

  if (material.loading && !material.data) {
    return <p className="empty">Loading teaching material…</p>;
  }

  if (material.error || !material.data) {
    return (
      <div className="stack">
        <Link to="/progress" className="small">← Back to Progress</Link>
        <div className="notice">That teaching material is not available.</div>
      </div>
    );
  }

  return (
    <div className="stack">
      <div>
        <Link to="/progress" className="small">← Back to Progress</Link>
      </div>
      <GrooveSnapshotPlayer
        key={material.data.query}
        title={material.data.title}
        query={material.data.query}
        practiceInstructions={material.data.practiceInstructions}
      />
    </div>
  );
}
